module.exports = __webpack_public_path__ + "img/Subscribed Features Icon.b6f2b1ab.svg";